/**
 * Created by js on 07.03.2018.
 */

export default class Form{

    constructor(form_id)
    {
        this.$form = $('#'+form_id);

        if(this.$form.length)
        {
            this.init();
        }
        else
        {
            console.warn("Form / id: ", form_id + " not found!");
        }
    }

    init()
    {
        this.addListeners();
        this.$feedback = this.$form.parent().find('.form-feedback');
        this.$success_feedback = this.$form.parent().find('.success');
        this.$error_feedback = this.$form.parent().find('.error');

        if(this.$error_feedback.length)
            this.$error_feedback.click($.proxy(this.clear, this, true));
    }

    addListeners()
    {
        this.$form.on('submit', $.proxy(this.onSubmit, this));
    }

    removeListeners()
    {
        this.$form.off('submit', $.proxy(this.onSubmit, this));
    }

    onSubmit(e)
    {
        e.preventDefault();
        this.removeListeners();

        let $this = $(e.currentTarget);

        //console.log("Form.onSubmit() - data:",$this.serialize());

        //submit data
        $.ajax({
            url     : $this.attr('action'),
            type    : $this.attr('method'),
            dataType: 'json',
            data    : $this.serialize(),
            success : $.proxy(this.onSuccess, this),
            error   : $.proxy(this.onError, this)
        });
    }
    
    onSuccess(data){
        console.log('Form Submitted', data);

        if(this.$success_feedback.length)
            this.$success_feedback.fadeIn().delay(3000).fadeOut();

        this.clear();
    }
    
    onError(xhr, err)
    {
        console.warn('Form Error', xhr, err);

        if(this.$error_feedback.length)
            this.$error_feedback.fadeIn();


    }

    clear(with_feedback)
    {

        console.log("Form clear");

        $(':input', this.$form).each(function() {
            let type = this.type;
            let tag = this.tagName.toLowerCase();
            if (type == 'text' || type == 'password' || type == 'email' || tag == 'textarea')
            {
                this.value = "";
            }
            else if (type == 'checkbox' || type == 'radio')
            {
                this.checked = false;
            }
            // select elements need to have their 'selectedIndex' property set to -1
            // (this works for both single and multiple select elements)
            else if (tag == 'select')
            {
                this.selectedIndex = -1;
            }
        });

        this.addListeners();

        if(with_feedback && this.$feedback.length)
            this.$feedback.fadeOut();
    }
}


// WEBPACK FOOTER //
// ./src/script/form.js